module.exports = __webpack_public_path__ + "static/pttk-5fb6d92d2b52ba258005648b7abe7587.png";